import React from "react";
import classes from "./Chip.scss";
import classNames from "classnames";

const LabelChip = props => {
  const { label, onClick, type, isSelected = false } = props;

  return (
    <button
      data-elm="module-filter-item"
      data-test-id={`globalSearch-modulesSection-moduleFilterItem-${type}`}
      className={classNames(classes.chipContainer, {
        [classes.selected]: isSelected,
      })}
      onClick={onClick}
    >
      <div className="text-body-2 whitespace-nowrap">{label}</div>
    </button>
  );
};

export default LabelChip;
